import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/images/flight-experience-underline.svg'
import _imports_1 from '@/assets/images/noneAudio.png'


const _hoisted_1 = { class: "new-grade" }
const _hoisted_2 = { class: "container-top" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "container-bottom" }
const _hoisted_5 = { class: "sceneCategory" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "flight-experience-total"
}
const _hoisted_8 = { class: "duration" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "number" }
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { class: "form" }
const _hoisted_13 = {
  key: 0,
  class: "btns"
}
const _hoisted_14 = { class: "bottom-box" }
const _hoisted_15 = { class: "statistics" }
const _hoisted_16 = { class: "typeObj" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "describe" }
const _hoisted_19 = {
  key: 0,
  class: "text2"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text2"
}
const _hoisted_22 = {
  key: 0,
  class: "item"
}
const _hoisted_23 = { class: "describe" }
const _hoisted_24 = {
  key: 0,
  class: "text2"
}
const _hoisted_25 = {
  key: 1,
  class: "text2"
}
const _hoisted_26 = {
  key: 1,
  class: "item"
}
const _hoisted_27 = { class: "describe" }
const _hoisted_28 = {
  key: 0,
  class: "text2"
}
const _hoisted_29 = { class: "small" }
const _hoisted_30 = {
  key: 1,
  class: "text2"
}
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "describe" }
const _hoisted_33 = {
  key: 0,
  class: "text2"
}
const _hoisted_34 = { class: "small" }
const _hoisted_35 = {
  key: 1,
  class: "text2"
}
const _hoisted_36 = { class: "item" }
const _hoisted_37 = { class: "describe" }
const _hoisted_38 = {
  key: 0,
  class: "text2"
}
const _hoisted_39 = {
  key: 1,
  class: "text2"
}
const _hoisted_40 = { class: "echarts" }
const _hoisted_41 = { class: "noData" }
const _hoisted_42 = {
  key: 0,
  class: "anomalyData"
}
const _hoisted_43 = { class: "text" }
const _hoisted_44 = {
  class: "flightRecords",
  "element-loading-background": "rgba(0, 0, 0, 0.0)"
}
const _hoisted_45 = { class: "table" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "abnormal-analysis" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "abnormal-analysis" }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["onClick"]

import { ref, reactive, onMounted, watch, computed,onUnmounted } from 'vue'
import { useStore } from 'vuex'
import * as echarts from 'echarts';
import {
  getSceneTypes,
  getSecondaryPageData,
  getSceneSubTypeDropdownList,
  getMistakeTypeDropdownList,
  getTrainingDataByPage,
  getUserTrainingStatisticsByLimit,
  getUserOverallFlyTime,
  getUserTestStatisticsByLimit,
  getMistakeStatisticsByLimit,
  getTestDataByPage
} from '@/service'
import { $enum, $config } from '@/global/index'
import Achievement from './achievement/index.vue'
import Ranking from './ranking/index.vue'
import Score from './score/index.vue'
import CapabilityAnalysis from './capability-analysis/index.vue'
import GradeSettlement from './score/GradeSettlement.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()
const state = reactive({
  sceneList: [] as any[],
  sceneIndex: 0,
  overallFlyTimeSeconds: 0,
  sceneCategoryList: [] as any[],
  sceneCategoryIndex: 0,
  formData: {
    sceneSubTypeId: '',
    mistakeTypeId: '',
    date: '',
  },
  sceneSubTypeList: [] as any[],
  mistakeList: [] as any[],
  trainingStatistics: {},
  chart: null as any,
  chartTotal: null as any,
  option: {
    width: '100%',
    height: '100%',
    tooltip: {
      show: false
    },
    copyright: {
      show: false
    },
    legend: {
      show: false
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: ['60%', '94%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        // padAngle: 2,
        itemStyle: {
          borderRadius: 6,
        },
        labelLine: {
          show: false
        },
        label: {
          show: false
        },
        data: []
      }
    ],
    graphic: [],
  },
  permissionLevel:null,
  loading: false,
  columns: [
    { prop: 'index', label: '序号', width: '70', },
    { prop: 'trainingTime', label: '完成时间', width: '200', },
    { prop: 'trainingTypeName', label: '科目' },
    { prop: 'overallTime', label: '用时', slotName: 'overallTime' },
    { prop: 'overallScore', label: '得分', slotName: 'overallScore' },
    { prop: 'isPass', label: '评价', slotName: 'isPass' },
    { prop: 'mistakes', label: '异常分析', slotName: 'mistakes' },
    { prop: 'option', label: '操作', width: '150', slotName: 'option',fixed:'right' },
  ],
  columns2: [
    { prop: 'index', label: '序号', width: '70', },
    { prop: 'trainingTypeName', label: '关卡名称', },
    { prop: 'firstTrainingTime', label: '初始测试时间' },
    { prop: 'lastTrainingTime', label: '最近测试时间' },
    { prop: 'passNum', label: '合格/总场次', slotName: 'passNum' },
    { prop: 'isPass', label: '关卡状态', slotName: 'isPass',fixed:'right'},
  ],
  columns3: [
    { prop: 'index', label: '序号', width: '70', },
    { prop: 'trainingTime', label: '完成时间', },
    { prop: 'overallTime', label: '用时', slotName: 'overallTime' },
    { prop: 'overallScore', label: '得分', slotName: 'overallScore' },
    { prop: 'isPass', label: '评价', slotName: 'isPass' },
    { prop: 'mistakes', label: '异常分析', slotName: 'mistakes' },
    { prop: 'option', label: '操作', width: '150', slotName: 'option',fixed:'right' },
  ],
  tableData: [] as any[],
  pagination: { pageNum: 1, pageSize: 20, totalPage: 1, totalCount: 0 },
  trainingId: 0,
  mistakeName: '',
  anomalyData: [] as any[],
  crash: false,
  showCaacGrade: false,
  showTrainsmitScore: false,
  currentRow: {} as any,
})

// 异常类型颜色映射
const anomalyDataMap = new Map([
  ['1', {color: '#64C574'}],
  ['2', {color: '#FDE043'}],
  ['3', {color: '#EE4540'}],
  ['4', {color: '#3CB1FB'}],
  ['5', {color: '#FFBC43'}],
  ['6', {color: '#38B6C7'}],
  ['51', {color: '#EE4540'}],
  ['52', {color: '#FFBC43'}],
  ['100', {color: '#2174FF'}],
  ['101', {color: '#C054C5'}],
  ['102', {color: '#FDE043'}],
  ['103', {color: '#A3040F'}], 
]);
const capabilityShow = ref(false)


onMounted(() => {
  window.addEventListener('resize', resizeWindow)
  onInitData()
  initChart()
});
onUnmounted(() => {
  window.removeEventListener('resize', resizeWindow)
  overallFlyTimeRequestId++
})

let overallFlyTimeRequestId = 0
const overallFlyTimeHours = computed(() => String(Math.floor(state.overallFlyTimeSeconds / 3600)).padStart(2, '0'))
const overallFlyTimeMinutes = computed(() => String(Math.floor((state.overallFlyTimeSeconds % 3600) / 60)).padStart(2, '0'))

async function refreshOverallFlyTime() {
  const scene = state.sceneList[state.sceneIndex]
  const requestId = ++overallFlyTimeRequestId
  state.overallFlyTimeSeconds = 0
  if (scene?.courseTypeId != $enum.CourseTypeEnum.CAAC多旋翼) {
    return
  }
  const params = {
    userId: store.state.persistence.userInfo.userId,
    tenantId: store.state.persistence.currentTenantId,
    sceneTypeId: scene.id,
  }
  try {
    const { code, data } = await getUserOverallFlyTime(params)
    if (requestId !== overallFlyTimeRequestId) return
    if (code == $enum.EnumResult.SUCCESS && (data === null || (typeof data === 'number' && Number.isFinite(data) && data >= 0))) {
      state.overallFlyTimeSeconds = data ?? 0
    }
  } catch {
    // 请求失败时保留本次调用前设置的零值。
  }
}

// 禁用未来日期的函数
const disabledFutureDate = (date: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); 
  return date && date > today;
};

function initChart() {
  const chartDom = document.getElementById('echartsId');
  state.chart = echarts.init(chartDom);
  state.chart.setOption(state.option);
  state.chart.on('mouseover', function (params) {
    if (params.componentType === 'series' && params.seriesType === 'pie') {
      state.chart.setOption({
        graphic: setGraphic(params)
      });
    }
  });
  state.chart.on('mouseout', function (params) {
    if (params.componentType === 'series' && params.seriesType === 'pie') {
      state.chart.setOption({
        graphic: setGraphic(params)
      });
    }
  });
  state.chart.on('highlight', function (params) {
    if (params.name) {
      const item = state.option.series[0].data.find(d => d.name === params.name);
      if (item) {
        state.chart.setOption({
          graphic: setGraphic(params)
        });
      }
    }
  });
}

function handleMouseLeaveEcharts(){
   state.option.graphic = setGraphic({
    value: state.chartTotal,
    name: '总量',
  })
  state.chart.setOption({ ...state.option });
}

function setGraphic(params: any){
  return [
    {
      // 数字部分（居上）
      type: 'text',
      style: {
        text: params.value,
        font:'normal 24px DIN-BlackItalic',
        fill: '#FFFFFFE5',
      },
      left: 'center',
      top: '40%',
      textAlign: 'center',
      verticalAlign: 'middle'
    },
    {
      // 文字部分（居下）
      type: 'text',
      style: {
        text: params.name,
        font:'normal 16px DIN-BlackItalic',
        fill: '#FFFFFF99'
      },
      left: 'center',
      top: '56%',
      textAlign: 'center',
      verticalAlign: 'middle'
    }
  ]
}

const achievement = ref<any>(null);
const ranking = ref<any>(null);
async function onInitData() {
  state.loading = true;
  const param = {
    userId: store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId
  }
  const sceneRes = await getSceneTypes(param)
  if (sceneRes.code == $enum.EnumResult.SUCCESS) {
    state.sceneList = sceneRes.data as any[];
    // if(state.sceneList.length>0){
    //   const firstItem = state.sceneList[0]
    //   state.permissionLevel = firstItem?.permissionLevel && firstItem?.permissionLevel !== undefined && firstItem?.permissionLevel !== null ? firstItem?.permissionLevel : null
    // }
  }
  await onSceneCategory()
  await onGetSceneSubTypeDropdownList();
  await onGetMistakeTypeDropdownList();
  await onGetUserTrainingStatisticsByLimit()
  await onGetMistakeStatisticsByLimit()
  await getTrainingList()
}
async function onSceneCategory() {
  const userId = store.state.persistence.userInfo.userId;
  const sceneTypeId = state.sceneList[state.sceneIndex].id;
  const tenantId = store.state.persistence.currentTenantId
  state.sceneCategoryList = []
  const { code, data, message } = await getSecondaryPageData({ userId, sceneTypeId, tenantId })
  if (code == $enum.EnumResult.SUCCESS) {
    state.sceneCategoryList = data.sceneCategoryTabVoList;
  }
}
async function onGetSceneSubTypeDropdownList() {
  state.sceneSubTypeList = []
  const { code, data, message } = await getSceneSubTypeDropdownList({ id: state.sceneList[state.sceneIndex].id })
  if (code == $enum.EnumResult.SUCCESS) {
    state.sceneSubTypeList = data as any[];
  }
}
async function onGetMistakeTypeDropdownList() {
  state.mistakeList = []
  const { code, data, message } = await getMistakeTypeDropdownList({ id: state.sceneList[state.sceneIndex].id })
  if (code == $enum.EnumResult.SUCCESS) {
    state.mistakeList = data as any[];
  }
}
function getParams() {
  return {
    userId: store.state.persistence.userInfo.userId,
    tenantId: store.state.persistence.currentTenantId,
    sceneTypeId: state.sceneList[state.sceneIndex].id,
    sceneCategoryId: state.sceneCategoryList[state.sceneCategoryIndex].id,
    sceneSubTypeId: state.formData.sceneSubTypeId,
    mistakeTypeId: state.formData.mistakeTypeId,
    size: state.pagination.pageSize,
    current: state.pagination.pageNum,
    startTime: state.formData.date ? `${formatDate(state.formData.date[0])} 00:00:00` : null,
    endTime: state.formData.date ? `${formatDate(state.formData.date[1])} 23:59:59` : null,
  }
}
async function onGetUserTrainingStatisticsByLimit() {
  const params = getParams()
  state.trainingStatistics = {}
  const { code, data, message } = state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName !== '通关测试' ? await getUserTrainingStatisticsByLimit(params) : await getUserTestStatisticsByLimit(params)
  if (code == $enum.EnumResult.SUCCESS) {
    state.trainingStatistics = data;
    if (data.flyTime) {
      state.trainingStatistics.hour = formatTime(data.flyTime).hour;
      state.trainingStatistics.minutes = formatTime(data.flyTime).minutes;
    }
  }
}
async function onGetMistakeStatisticsByLimit() {
  state.anomalyData = [];
  const { code, data, message } = await getMistakeStatisticsByLimit(getParams());
  if (code == $enum.EnumResult.SUCCESS) {
    if (data) {
      let chartTotal = 0;
      let anomalyArr = [] as any[];
      state.option.series[0].data = data.map((item: any) => {
        anomalyArr.push({
          label: item.mistakeTypeName,
          value: item.mistakeNum,
          color: anomalyDataMap.get(item.mistakeTypeId)?.color || '#000',
        })
        chartTotal += item.mistakeNum;
        return {
          value: item.mistakeNum,
          name: item.mistakeTypeName,
          itemStyle: {
            color: anomalyDataMap.get(item.mistakeTypeId)?.color || '#000',
          }
        }
      });
      state.chartTotal = chartTotal;
      state.option.graphic = setGraphic({
        value: chartTotal,
        name: '总量',
      })
      state.chart.setOption({ ...state.option });
      state.anomalyData = anomalyArr;
    }
  }
}
async function getTrainingList() {
  state.tableData = []
  state.pagination.totalCount = 0
  state.loading = true;
  const { code, data, message } = state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName !== '通关测试' ? await getTrainingDataByPage(getParams()) : await getTestDataByPage(getParams());
  if (code == $enum.EnumResult.SUCCESS) {
    if (data.records && data.records.length) {
      data.records.forEach((item: any, index: number) => {
        item.index = (state.pagination.pageNum - 1) * state.pagination.pageSize + index + 1;
      })
      state.tableData = data.records;
      state.pagination.totalCount = Number(data.total);
    } else {
      state.tableData = [];
      state.pagination.totalCount = 0;
    }
  }
  state.loading = false;
}



async function onClickScene(item: any, index: number) {
  state.loading = true;
  // state.permissionLevel = item?.permissionLevel !== undefined && item?.permissionLevel !== null ? item?.permissionLevel : null
  window?.playClick()
  if (state.sceneIndex !== index) {
    state.sceneIndex = index;
    state.sceneCategoryIndex = 0;
    state.formData = {
      sceneSubTypeId: '',
      mistakeTypeId: '',
      date: '',
    };
    state.tableData = [];
    // 更新二级分类
    await onSceneCategory()
    // 更新下拉数据
    await onGetSceneSubTypeDropdownList()
    await onGetMistakeTypeDropdownList()
    //更新数据统计
    await onGetUserTrainingStatisticsByLimit()
    // 更新异常数据
    await onGetMistakeStatisticsByLimit()
    // 更新飞行记录
    state.pagination.pageNum = 1;
    state.pagination.totalPage = 1;
    getTrainingList()
  }
}

watch(()=>state.sceneList[state.sceneIndex],async (newVal,oldVal)=>{
  refreshOverallFlyTime()
  let arr = [...state.columns]
  let arr3 = [...state.columns3]
  if(newVal && newVal?.id == 7){
    state.columns = addIfNotExists(arr,'inspectionStatus')
    state.columns3 = [...arr]
  }else{
    state.columns = deleteExists(arr,'inspectionStatus')
    let newArr = deleteExists(arr3,'trainingTypeName')
    newArr =  deleteExists(arr3,'inspectionStatus')
    state.columns3 = [...newArr]
  }
  const overallTimeLabel = newVal?.courseTypeId == $enum.CourseTypeEnum.CAAC多旋翼 ? '飞行经历时长' : '用时'
  state.columns = state.columns.map(column => column.prop === 'overallTime' ? { ...column, label: overallTimeLabel } : column)
  state.columns3 = state.columns3.map(column => column.prop === 'overallTime' ? { ...column, label: overallTimeLabel } : column)
})

function addIfNotExists(arr:any[],keyValue:string) {
  const exists = arr.find(item => item['prop'] === keyValue);
  if (!exists) {
    const index = arr.findIndex(item => item['prop'] === 'overallTime');
    arr.splice(index + 1, 0, { prop: 'inspectionStatus', label: '巡检状态' },);
  } 
  return arr;
}

function deleteExists(arr:any[],keyValue:string) {
  const exists = arr.find(item => item['prop'] === keyValue);
  if (exists) {
    const index = arr.findIndex(item => item['prop'] === keyValue);
    arr.splice(index, 1);
  } 
  return arr;
}
async function onClickSceneCategory(item: any, index: number) {
  state.loading = true;
  state.tableData = [];
  window?.playClick()
  if (state.sceneCategoryIndex !== index) {
    state.sceneCategoryIndex = index;
    state.formData = {
      sceneSubTypeId: '',
      mistakeTypeId: '',
      date: '',
    };
    // 更新下拉数据
    await onGetSceneSubTypeDropdownList()
    await onGetMistakeTypeDropdownList()
    // 更新数据统计
    await onGetUserTrainingStatisticsByLimit()
    // 更新异常数据
    await onGetMistakeStatisticsByLimit()
    // 更新飞行记录
    state.pagination.pageNum = 1;
    state.pagination.totalPage = 1;
    getTrainingList()
  }
}
async function onClickQuery() {
  state.loading = true;
  window?.playClick();
  // 更新数据统计
  await onGetUserTrainingStatisticsByLimit()
  // 更新异常数据
  await onGetMistakeStatisticsByLimit()
  // 更新飞行记录
  state.pagination.pageNum = 1;
  state.pagination.totalPage = 1;
  getTrainingList()
}
async function onClickReset() {
  state.loading = true;
  window?.playClick();
  state.formData = {
    sceneSubTypeId: '',
    mistakeTypeId: '',
    date: '',
  };
  // 更新数据统计
  await onGetUserTrainingStatisticsByLimit()
  // 更新异常数据
  await onGetMistakeStatisticsByLimit()
  // 更新飞行记录
  state.pagination.pageNum = 1;
  state.pagination.totalPage = 1;
  getTrainingList()
}

function handleChangePage(val: number) {
  state.pagination.pageNum = val;
  getTrainingList()
}
function handleChangeSize(val: number) {
  state.pagination.pageSize = val;
  state.pagination.pageNum = 1;
  getTrainingList()
}
function onClickBtn(type: string) {
  window?.playClick()
  if (type === 'grade') {
    achievement.value.showModel = true;
  } else if (type === 'ranking') {
    // 跳转排行榜
    ranking.value.showModel = true;
  } else if (type === 'capability') {
    // 跳转能力分析
    capabilityShow.value = true;
  }
}
function onClickResult(row: any) {
  if (row.hasDetail) {
    state.trainingId = row.id;
    state.crash = false;
    state.mistakeName = '';
    state.currentRow = row;
    state.permissionLevel = row?.permissionLevel !== undefined && row?.permissionLevel !== null ? row?.permissionLevel : null;
    row.mistakes.forEach((item: any) => {
      if(item.mistakeName == '炸机' && !state.crash){
        state.crash = true;
      }
    })
    window?.playClick()
    setTimeout(() => {
      if(state.sceneList[state.sceneIndex]?.courseTypeId == $enum.CourseTypeEnum.电力巡检){
        state.showTrainsmitScore = true;
      }
      if(state.sceneList[state.sceneIndex]?.courseTypeId == $enum.CourseTypeEnum.CAAC多旋翼){
        state.showCaacGrade = true;
      }
    }, 50);
  }
}
function formatDate(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
function formatTime(seconds) {
  seconds = Number(seconds); // 确保是数字
  const hour = Math.floor(seconds / 3600); // 小时
  const minutes = Math.floor((seconds % 3600) / 60); // 剩余分钟
  const secs = seconds % 60; // 剩余秒
  const timeStr = `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  return {
    time: timeStr,                // hh:mm:ss 格式
    hour: hour,                   // 完整小时数
    minutes: minutes              // 剩余分钟（小于60）
  };
}
function formatFlexibleTime(timeStr: string) {
  const totalSeconds = Number(timeStr);
  if (isNaN(totalSeconds)) return "00:00";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  if (hours === 0 && minutes === 0 && seconds === 0) {
    return "00:00";
  } else if (hours === 0 && minutes === 0) {
    return `00:${String(seconds).padStart(2, '0')}`;
  } else if (hours === 0) {
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  } else {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }
}

function resizeWindow(){
  state.chart.resize()
  const graphic = state.chart.getOption().graphic || []
  state.chart.setOption({ ...state.option, graphic });
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_vke_table = _resolveComponent("vke-table")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.sceneList, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["grade-nav-item", { 'grade-nav-item-active': state.sceneIndex == index }]),
          onClick: ($event: any) => (onClickScene(item, index))
        }, [
          _createElementVNode("span", null, _toDisplayString(item.courseTypeName) + "-" + _toDisplayString(item.sceneName), 1)
        ], 10, _hoisted_3)), [
          [_vShow, !item.isLocked]
        ])
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.sceneCategoryList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: ($event: any) => (onClickSceneCategory(item, index))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(index === state.sceneCategoryIndex ? 'name name2' : 'name')
            }, _toDisplayString(item.sceneCategoryName), 3),
            _createElementVNode("div", {
              class: _normalizeClass(index === state.sceneCategoryIndex ? 'round round2' : 'round')
            }, null, 2)
          ], 8, _hoisted_6))
        }), 128)),
        (state.sceneList[state.sceneIndex]?.courseTypeId == _unref($enum).CourseTypeEnum.CAAC多旋翼)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "飞行经历总时长", -1)),
              _createElementVNode("div", _hoisted_8, [
                _cache[10] || (_cache[10] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(overallFlyTimeHours.value), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "unit" }, "h", -1)),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(overallFlyTimeMinutes.value), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "unit" }, "min", -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_form, {
          inline: true,
          model: state.formData,
          class: "el-form"
        }, {
          default: _withCtx(() => [
            (state.sceneCategoryList[state.sceneCategoryIndex] && state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName === '科目训练')
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: state.formData.sceneSubTypeId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.formData.sceneSubTypeId) = $event)),
                      placeholder: "请选择科目",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.sceneSubTypeList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.subSceneName,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { class: "date-picker-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "picker",
                  teleported: false,
                  "popper-class": "date-popper",
                  modelValue: state.formData.date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.formData.date) = $event)),
                  type: "daterange",
                  "range-separator": "To",
                  "start-placeholder": "开始日期时间",
                  "end-placeholder": "结束日期时间",
                  size: "large",
                  "disabled-date": disabledFutureDate
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (state.sceneCategoryList[state.sceneCategoryIndex] && state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName != '通关测试')
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: state.formData.mistakeTypeId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.formData.mistakeTypeId) = $event)),
                      placeholder: "请选择异常分析",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.mistakeList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.mistakeName,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_vkn_button, {
                  label: "查询",
                  type: "info",
                  "icon-placement": "left",
                  size: "medium",
                  onClick: onClickQuery
                }),
                _createVNode(_component_vkn_button, {
                  label: "重置",
                  type: "info",
                  "icon-placement": "left",
                  size: "medium",
                  onClick: onClickReset
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        (state.sceneCategoryList[state.sceneCategoryIndex] && state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName === '模拟考核')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickBtn('grade')))
              }, [
                _createVNode(_component_vkm_svg, {
                  "icon-name": "grade",
                  class: "icon"
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" 我的等级 "))
              ]),
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickBtn('ranking')))
              }, [
                _createVNode(_component_vkm_svg, {
                  "icon-name": "ranking",
                  class: "icon"
                }),
                _cache[13] || (_cache[13] = _createTextVNode(" 排行榜 "))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "title" }, " 数据统计 ", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_vkm_svg, {
                "icon-name": "statistics_time",
                class: "icon"
              }),
              _createElementVNode("div", _hoisted_18, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text1" }, "飞行总时长", -1)),
                (state.trainingStatistics.flyTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (state.trainingStatistics.hour)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createTextVNode(_toDisplayString(state.trainingStatistics.hour) + " ", 1),
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "small" }, "h", -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(state.trainingStatistics.minutes) + " ", 1),
                      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "small" }, "min", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, "--"))
              ])
            ]),
            (state.sceneCategoryList[state.sceneCategoryIndex] && state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName !== '通关测试')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_vkm_svg, {
                    "icon-name": "statistics_fraction",
                    class: "icon"
                  }),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text1" }, "最高得分", -1)),
                    (state.trainingStatistics.maxScore)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(state.trainingStatistics.maxScore), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, "--"))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_vkm_svg, {
                    "icon-name": "tongguan",
                    class: "icon"
                  }),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text1" }, "通关关卡", -1)),
                    (state.trainingStatistics.passTrainingTypeNum || state.trainingStatistics.trainingTypeNum)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createTextVNode(_toDisplayString(state.trainingStatistics.passTrainingTypeNum) + " ", 1),
                          _createElementVNode("div", _hoisted_29, "/" + _toDisplayString(state.trainingStatistics.trainingTypeNum), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, "--"))
                  ])
                ])),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_vkm_svg, {
                "icon-name": "statistics_frequency",
                class: "icon"
              }),
              _createElementVNode("div", _hoisted_32, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text1" }, "合格/总场次", -1)),
                (state.trainingStatistics.passNum || state.trainingStatistics.scoreNum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createTextVNode(_toDisplayString(state.trainingStatistics.passNum) + " ", 1),
                      _createElementVNode("div", _hoisted_34, "/" + _toDisplayString(state.trainingStatistics.scoreNum), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, "--"))
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_vkm_svg, {
                "icon-name": "statistics_qualified",
                class: "icon"
              }),
              _createElementVNode("div", _hoisted_37, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text1" }, "合格率", -1)),
                (state.trainingStatistics.passRate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createTextVNode(_toDisplayString(state.trainingStatistics.passRate) + " ", 1),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "small" }, "%", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_39, "--"))
              ])
            ])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "title anomaly-title" }, " 异常分析统计 ", -1)),
          _createElementVNode("div", _hoisted_40, [
            _withDirectives(_createElementVNode("div", {
              id: "echartsId",
              onMouseleave: handleMouseLeaveEcharts
            }, null, 544), [
              [_vShow, state.option.series[0].data.length != 0]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_41, _cache[22] || (_cache[22] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "暂无数据", -1)
            ]), 512), [
              [_vShow, state.option.series[0].data.length == 0]
            ])
          ]),
          (state.anomalyData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.anomalyData, (anomalyItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: anomalyItem.label,
                    class: "item"
                  }, [
                    _createElementVNode("div", {
                      class: "dot",
                      style: _normalizeStyle({ background: anomalyItem.color })
                    }, null, 4),
                    _createElementVNode("span", _hoisted_43, _toDisplayString(anomalyItem.label), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_44, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "title" }, " 飞行记录 ", -1)),
          _createElementVNode("div", _hoisted_45, [
            (state.sceneCategoryList[state.sceneCategoryIndex] && state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName === '科目训练')
              ? (_openBlock(), _createBlock(_component_vke_table, {
                  key: 0,
                  columns: state.columns,
                  tableData: state.tableData,
                  "show-pagination": true,
                  pagination: state.pagination,
                  onPageChange: handleChangePage,
                  onSizeChange: handleChangeSize
                }, {
                  overallTime: _withCtx(({ scope }) => [
                    _createElementVNode("span", null, _toDisplayString(formatFlexibleTime(scope.row.overallTime)), 1)
                  ]),
                  overallScore: _withCtx(({ scope }) => [
                    (scope.row.overallScore != undefined && scope.row.overallScore != null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(Number(scope.row.overallScore).toFixed(0)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_47, "--"))
                  ]),
                  isPass: _withCtx(({ scope }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(scope.row.isPass === false ? 'nopass' : scope.row.isPass === true ? 'ispass' : 'evaluation')
                    }, _toDisplayString(scope.row.isPass === false ? '不合格' : scope.row.isPass === true ? '合格' : '--'), 3)
                  ]),
                  mistakes: _withCtx(({ scope }) => [
                    (scope.row.mistakes && scope.row.mistakes.length)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          class: "box-item",
                          effect: "dark",
                          content: scope.row.mistakes.map(item => item.mistakeName).join(';'),
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_48, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.mistakes, (item, index) => {
                                return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item.mistakeName) + _toDisplayString(scope.row.mistakes.length - 1 === index ? '' : ';'), 1))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_49, "--"))
                  ]),
                  option: _withCtx(({ scope }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(!scope.row.hasDetail ? 'action-btn action-btn2' : 'action-btn'),
                      onClick: ($event: any) => (onClickResult(scope.row))
                    }, "查看结果", 10, _hoisted_50)
                  ]),
                  _: 1
                }, 8, ["columns", "tableData", "pagination"]))
              : (state.sceneCategoryList[state.sceneCategoryIndex] && state.sceneCategoryList[state.sceneCategoryIndex].sceneCategoryName === '通关测试')
                ? (_openBlock(), _createBlock(_component_vke_table, {
                    key: 1,
                    columns: state.columns2,
                    tableData: state.tableData,
                    "show-pagination": true,
                    pagination: state.pagination,
                    onPageChange: handleChangePage,
                    onSizeChange: handleChangeSize
                  }, {
                    passNum: _withCtx(({ scope }) => [
                      (scope.row.passNum != undefined && scope.row.passNum != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(`${scope.row.passNum}/${scope.row.scoreNum}`), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_52, "--"))
                    ]),
                    isPass: _withCtx(({ scope }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(scope.row.isPass === false ? 'nopass' : scope.row.isPass === true ? 'ispass' : 'evaluation')
                      }, _toDisplayString(scope.row.isPass === false ? '未通关' : scope.row.isPass === true ? '已通关' : '--'), 3)
                    ]),
                    _: 1
                  }, 8, ["columns", "tableData", "pagination"]))
                : (_openBlock(), _createBlock(_component_vke_table, {
                    key: 2,
                    columns: state.columns3,
                    tableData: state.tableData,
                    "show-pagination": true,
                    pagination: state.pagination,
                    onPageChange: handleChangePage,
                    onSizeChange: handleChangeSize
                  }, {
                    overallTime: _withCtx(({ scope }) => [
                      _createElementVNode("span", null, _toDisplayString(formatFlexibleTime(scope.row.overallTime)), 1)
                    ]),
                    overallScore: _withCtx(({ scope }) => [
                      (scope.row.overallScore != undefined && scope.row.overallScore != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(Number(scope.row.overallScore).toFixed(0)), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_54, "--"))
                    ]),
                    isPass: _withCtx(({ scope }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(scope.row.isPass === false ? 'nopass' : scope.row.isPass === true ? 'ispass' : 'evaluation')
                      }, _toDisplayString(scope.row.isPass === false ? '不合格' : scope.row.isPass === true ? '合格' : '--'), 3)
                    ]),
                    mistakes: _withCtx(({ scope }) => [
                      (scope.row.mistakes && scope.row.mistakes.length)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            class: "box-item",
                            effect: "dark",
                            content: scope.row.mistakes.map(item => item.mistakeName).join(';'),
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_55, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.mistakes, (item, index) => {
                                  return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item.mistakeName) + _toDisplayString(scope.row.mistakes.length - 1 === index ? '' : ';'), 1))
                                }), 128))
                              ])
                            ]),
                            _: 2
                          }, 1032, ["content"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_56, "--"))
                    ]),
                    option: _withCtx(({ scope }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(!scope.row.hasDetail ? 'action-btn action-btn2' : 'action-btn'),
                        onClick: ($event: any) => (onClickResult(scope.row))
                      }, "查看结果", 10, _hoisted_57)
                    ]),
                    _: 1
                  }, 8, ["columns", "tableData", "pagination"]))
          ])
        ])), [
          [_directive_loading, state.loading]
        ])
      ]),
      _createVNode(Achievement, {
        ref_key: "achievement",
        ref: achievement,
        sceneId: "",
        sceneTypeId: state.sceneList[state.sceneIndex] && state.sceneList[state.sceneIndex].id ? state.sceneList[state.sceneIndex].id : null,
        courseTypeId: state.sceneList[state.sceneIndex]?.courseTypeId
      }, null, 8, ["sceneTypeId", "courseTypeId"]),
      _createVNode(Ranking, {
        ref_key: "ranking",
        ref: ranking,
        sceneId: state.sceneList[state.sceneIndex] && state.sceneList[state.sceneIndex].id ? state.sceneList[state.sceneIndex].id : null
      }, null, 8, ["sceneId"]),
      (state.showTrainsmitScore)
        ? (_openBlock(), _createBlock(Score, {
            key: 0,
            ref: "score",
            id: state.trainingId,
            mistakeName: state.mistakeName,
            onOnClose: _cache[5] || (_cache[5] = ()=>{state.showTrainsmitScore = false}),
            scnenIndex: state.sceneList[state.sceneIndex]?.id,
            sceneTypeId: state.sceneList[state.sceneIndex]?.id,
            crash: state.crash
          }, null, 8, ["id", "mistakeName", "scnenIndex", "sceneTypeId", "crash"]))
        : _createCommentVNode("", true),
      (state.showCaacGrade)
        ? (_openBlock(), _createBlock(GradeSettlement, {
            key: 1,
            sceneTypeId: state.sceneCategoryList[state.sceneCategoryIndex]?.id,
            forbidAiCoach: state.permissionLevel,
            crash: state.crash,
            id: state.trainingId,
            replayTitle: state.currentRow?.trainingTypeName || '',
            onOnClose: _cache[6] || (_cache[6] = ()=>{state.showCaacGrade = false})
          }, null, 8, ["sceneTypeId", "forbidAiCoach", "crash", "id", "replayTitle"]))
        : _createCommentVNode("", true)
    ]),
    (capabilityShow.value)
      ? (_openBlock(), _createBlock(_component_vkm_modal, {
          key: 0,
          class: "capability-modal",
          title: "能力分析",
          onOnClose: _cache[7] || (_cache[7] = ()=>{capabilityShow.value = false})
        }, {
          content: _withCtx(() => [
            _createVNode(CapabilityAnalysis)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})